var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScatteredSnow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "0%",
    x2: "98.277%",
    y1: "0%",
    y2: "98.277%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F1F3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#DADCE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "100%",
    x2: "50%",
    y1: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F1F3F4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 12,
    r: 12,
    fill: "#F1F3F4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 12,
    r: 12,
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M20 24c0-5.523-4.477-10-10-10S0 18.477 0 24c.015-.023 20.005-.015 20 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4285F4",
    strokeLinecap: "square",
    d: "M28 10.429v5.142m-2.227-3.857 4.454 2.572m0-2.572-4.454 2.572M28 26.429v5.142m-2.227-3.857 4.454 2.572m0-2.572-4.454 2.572M20 18.429v5.142m-2.227-3.857 4.454 2.572m0-2.572-4.454 2.572"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScatteredSnow);
export default __webpack_public_path__ + "static/media/scattered_snow.11226e3867eab199ad37303cb23566c3.svg";
export { ForwardRef as ReactComponent };